'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');
const performanceMeasure = require('../../lib/performanceMeasure.js');
let measure = performanceMeasure('webcomponents:dropDown');

const eventTargetIsInDropDown = function (target, hostElements) {
    if (!target || !hostElements) {
        return;
    }

    return hostElements === target || hostElements.contains(target);
};
const OFFSET_SIZE = '5px';
const PAGE_CLICKED_EVENT_NAME = 'phoenix:page:clicked';

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * @example
     *  <phoenix-drop-down mouseenter class="m-dropdown">
     *      <button
     *          aria-expanded="false"
     *          id="toggle-drop-down"
     *          aria-controls="panel-drop-down"
     *          aria-haspopup="true"
     *          class="m-dropdown--toggler">Toggler</button>
     *      <div
     *          hidden
     *          id="panel-drop-down"
     *          aria-labelledby="toggle-drop-down"
     *          class="m-dropdown--container">
     *          Dropdown Content
     *      </div>
     * </phoenix-drop-down>
     */
    class PhoenixDropDown extends pageClass.PhoenixElement {
        get observedBroadcastedEvents() {
            return [PAGE_CLICKED_EVENT_NAME];
        }

        get isExpanded() {
            return this._isExpanded;
        }

        set isExpanded(val) {
            this._isExpanded = val;
            this.panel.hidden = !val;
            this.toggler.ariaExpanded = val;
        }

        connectedCallback() {
            super.connectedCallback();
            Promise.all([
                this.waitForElement('.m-dropdown--toggler', { untilDomReady: true }),
                this.waitForElement('.m-dropdown--container', { untilDomReady: true }),
            ]).then((elements) => {
                this.toggler = elements[0];
                this.panel = elements[1];
                this.toggler.addEventListener('click', this.handleToggler.bind(this));
                this.isSubMenuDropdown = this.panel.hasAttribute('is-sub-menu-dropdown');

                if (this.hasAttribute('mouseenter')) {
                    this.toggler.addEventListener('mouseenter', this.handleToggler.bind(this));
                }

                this.handlePanelOffset();
            });
        }

        handleToggler(e) {
            this.isExpanded = !this.isExpanded;
        }

        handlePanelOffset() {
            const panel = this.panel;
            panel.offScreenObserver = new IntersectionObserver((entries) => {
                const ele = entries[0];
                if (!this.isSubMenuDropdown) {
                    panel.style.left = 'unset';
                    panel.style.right = 'unset';
                }
                if (ele.isIntersecting && ele.intersectionRatio <= 1) {
                    if (ele.boundingClientRect.right >= window.innerWidth) {
                        panel.style.right = OFFSET_SIZE;
                    }
                }
            });
            panel.offScreenObserver.observe(panel);
        }

        broadcastedEventCallback(name, event = {}) {
            const eventTarget = event?.detail?.value?.target;
            if (
                name === PAGE_CLICKED_EVENT_NAME &&
                this.isExpanded &&
                !eventTargetIsInDropDown(eventTarget, this)
            ) {
                this.isExpanded = false;
            }
        }

        disconnectedCallback() {
            super.disconnectedCallback();
            this.toggler.removeEventListener('click', this.handleToggler);
            if (this.hasAttribute('mouseenter')) {
                this.toggler.removeEventListener('mouseenter', this.handleToggler);
            }
        }
    }
    window.customElements.define('phoenix-drop-down', PhoenixDropDown);
    measure.end();
});
